!(function () {
    function e(e) {
        if (e.is(".slick-initialized")) {
            var t = e.data("initWidth"),
                a = $(window).width();
            t !== a && (e.data("initWidth", a), e.slick("resize"));
        }
    }
    function t(e) {
        return !(e = $(e)).data("tplInitialized") && (e.data("tplInitialized", !0), !0);
    }
    function a(e) {
        return $(e).each(function () {
            $(this).html($(this).html().trim());
        });
    }
    function n(e, t) {
        var a = 0;
        return function () {
            var n = Date.now();
            n - a < t || ((a = n), e.apply({}, arguments));
        };
    }
    function i(e, t) {
        var a = $.ajax;
        $.ajax = function (n) {
            var i = a.apply($, arguments);
            if (n.url === e) {
                var o = i.done;
                i.done = function () {
                    return o.apply(i, [].slice.call(arguments).concat([t]));
                };
            }
            return i;
        };
    }
    function o(e, t) {
        e = $(e);
        var a = null;
        function n() {
            var n = 767 > $(window).width();
            n !== a && (n ? e.slick(t) : a && e.slick("destroy"), (a = n));
        }
        $(window).resize(n), n();
    }
    function r(e) {
        return $.get(e).then(function (e) {
            return $(e, document.implementation.createHTMLDocument(Math.random().toString()));
        });
    }
    function s(e) {
        for (var t, a = e.trim().toLowerCase().split(""), n = 0; n < a.length; n++) -1 !== (t = "ěščřž\xfd\xe1\xed\xe9ďť\xf3\xfaůňďť".indexOf(a[n])) && (a[n] = "escrzyaiedtouundt"[t]);
        return a
            .join("")
            .replace(/[^a-z0-9 ]+/g, "")
            .replace(/ +/g, "-");
    }
    tb.ajax;
    var d = {
            snippets: {},
            init: function () {
                var e,
                    t,
                    a = this;
                ((t = Object.keys((e = this.snippets))),
                $.when
                    .apply(
                        $,
                        t.map(function (t) {
                            return $.get("/user/documents/upload/snippets/" + e[t]);
                        })
                    )
                    .then(function () {
                        for (var e = [].slice.call(arguments), a = {}, n = 0; n < t.length; n++) a[t[n]] = t.length > 1 ? e[n][0] : e[n];
                        return a;
                    })).then(function (e) {
                    (a.snippets = e), a.snippetsLoaded && a.snippetsLoaded(), a._bindShoptetEvents();
                }),
                    a.bindEvents && a.bindEvents(),
                    a.documentReady && $(document).ready(this.documentReady.bind(this, this.snippets));
            },
            _bindShoptetEvents: function () {
                for (var e of shoptet.scripts.availableDOMLoadEvents) {
                    var t = e.replace(/^ShoptetDOM(.)/, function (e, t) {
                        return t.toLowerCase();
                    });
                    this[t] && ($(document).on(e, this[t].bind(this, this.snippets)), this[t](this.snippets));
                }
            },
        },
        l = Object.create(d);
    (l.snippets = {}),
        (l.documentReady = function () {
            this.initModalLinks();
        }),
        (l.cartContentLoaded = function () {}),
        (l.searchLoaded = function () {}),
        (l.contentLoaded = function () {
            this.wrapBanners();
        }),
        (l.initCartWidget = function () {}),
        (l.initSearchWhisperer = function () {}),
        (l.wrapBanners = function () {
            $(".extended-banner-title, .extended-banner-text, .extended-banner-link").each(function () {
                var e = $(this).parent();
                !e.is(".wrapper") && t(e, "wrapBanners") && e.children(".extended-banner-title, .extended-banner-text, .extended-banner-link").wrapAll("<div class='wrapper' />");
            });
        }),
        (l.initModalLinks = function () {
            $("body").on("click", "a.ajax-modal", function (e) {
                e.preventDefault();
                var t,
                    a,
                    n,
                    i = $(this).attr("data-selector") || "#content",
                    o = $(this).attr("data-size");
                (t = $(this).attr("href")),
                    (a = i),
                    (n = (n = (n = o) || "lg").slice(0, 1).toUpperCase() + n.slice(1).toLowerCase()),
                    r(t).then(function (e) {
                        var t = e.find(a);
                        t.length &&
                            shoptet.modal.open({
                                html: shoptet.content.colorboxHeader + t.html() + shoptet.content.colorboxFooter,
                                width: shoptet.modal.config["width" + n],
                                className: shoptet.modal.config["class" + n],
                                onComplete: function () {
                                    $(".colorbox-html-content img").unveil(),
                                        $("body").removeClass(shoptet.config.bodyClasses),
                                        $(".overlay").length > 0 && $(".overlay").detach(),
                                        setTimeout(function () {
                                            shoptet.modal.shoptetResize();
                                        }, 1);
                                },
                            });
                    });
            });
        }),
        (l.initSubmenuNav = function () {
            $(".navigation-in>ul>li").each(function () {
                var e = $(this).find(".menu-level-2");
                e.children("li").length > 8 && e.append(tb.$h("li.more-categories-trigger", [tb.$h("a", { href: "#" }, "Zobrazit všechny kategorie")])).addClass("more-categories");
            }),
                $("body").on("click", ".navigation-in .more-categories-trigger", function (e) {
                    e.preventDefault(), $(this).closest(".menu-level-2").addClass("more-categories-active"), $(this).remove();
                });
        }),
        (l.initBlogBlock = function () {
            var e = $(".blog-block .inner");
            e.length &&
                tb.ajax.loadDocument("/cache/blog/").then(function (t) {
                    var a = t.find(".news-wrapper");
                    a.children().slice(4).remove(),
                        e.append(a),
                        $("#newsWrapper .news-item").each(function () {
                            $(this).find('img').attr('src', $(this).find('img').attr('data-src'))
                            $(this).find("a.title").clone().insertAfter($(this).find(".text")).html("Cel\xfd čl\xe1nek").addClass("arrow");
                        }),
                        e.trigger("DynamicContentLoaded");
                });
        }),
        (l.initRefBlock = function () {
            var e = $(".heureka-block .inner"),
                t = $(".heureka-logo-block .number"),
                a = $(".heureka-logo-block .stars-here"),
                n = $(".heureka-logo-block .stars-row a");
            e.length &&
                tb.ajax.loadDocument("/cache/hodnoceni-obchodu/").then(function (i) {
                    i.find(".content-inner #ratingWrapper");
                    var o = i.find(".content-inner #ratingWrapper .rate-average"),
                        r = i.find(".content-inner .stars-label"),
                        s = i.find(".content-inner .rate-average-inner .stars"),
                        d = i.find(".content-inner .votes-wrap");
                    d.children().slice(5).remove(), a.append(s), n.prepend(r), t.append(o), e.append(d);
                    var l = $(".heureka-logo-block .rate-average");
                    if (l.length) {
                        var p = parseFloat(l.text().trim().replace(/,/, "."));
                        l.text(Math.round((p / 5) * 100));
                    }
                    $(".heureka-block .vote-wrap").each(function (e, t) {
                        $(this).find(".vote-header").insertAfter($(this).find(".vote-content")), $(this).find(".stars").insertBefore($(this).find(".vote-content")), $(this).find(".vote-header").wrapAll("<div class='stars-row'></div>");
                    }),
                        $(".heureka-block .star").attr("href", "/hodnoceni-obchodu/");
                });
        }),
        (l.initHowBlock = function () {
            var e = $("body.id-1633.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/jak-to-u-nas-chodi/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-1633 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initMembersBlock = function () {
            var e = $("body.id-1636.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/kolektiv-happyzoo/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-1636 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initBlogDetailBlock = function () {
            var e = $("body.in-blog.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/blog/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".in-blog .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item").each(function () {
                        $(this).find('img').attr('src', $(this).attr('data-src'))
                    }),
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initFreeSlots = function () {
            var e = $("body.id-2638.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/otevrene-pracovni-pozice/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-2638 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initAboutBuy = function () {
            var e = $("body.id-2641.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/vse-o-nakupu/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-2641 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initOthers = function () {
            var e = $("body.id-1642.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/jak-chovat/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-1642 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initDogs = function () {
            var e = $("body.id-1660.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/jak-chovat-psi-a-stenata/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-1660 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initBirds = function () {
            var e = $("body.id-1651.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/jak-chovat-ptaci/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-1651 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initRodents = function () {
            var e = $("body.id-1657.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/jak-chovat-hlodavci/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-1657 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initSpiders = function () {
            var e = $("body.id-1654.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/jak-chovat-plazi-a-pavouci/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-1654 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initTurtles = function () {
            var e = $("body.id-1648.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/jak-chovat-zelvy/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-1648 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initFrogs = function () {
            var e = $("body.id-1648.type-post .content-inner");
            e.length &&
                tb.ajax.loadDocument("/cache/jak-chovat-zelvy/").then(function (t) {
                    var a = t.find("#newsWrapper");
                    e.prepend(a), $(".id-1648 .news-item-detail").addClass("ready");
                    var n = window.location.pathname;
                    $("#newsWrapper .news-item .text a").each(function () {
                        var e = $(this).attr("href");
                        n == e && $(this).parent().parent().addClass("--active");
                    });
                });
        }),
        (l.initStoresBlock = function () {
            var e = $("body.in-index.desktop .homepage-box.middle-banners-wrapper .container, body.in-index.mobile .body-banners");
            e.length &&
                r("/cache/kontakty/").then(function (t) {
                    var a = t.find(".content-inner .stores");
                    e.append(a),
                        $(".stores__inner").slick({
                            infinite: !0,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            dots: !0,
                            responsive: [
                                { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                                { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                            ],
                        }),
                        $("<div class='center'><a href='/kontakty/' class='btn btn-secondary'>Zobrazit prodejny</a></div>").insertAfter(".stores__inner");
                });
        });
    var p = Object.create(d);
    (p.documentReady = function () {
        this.initCarouselIndicators();
    }),
        (p.initCarouselIndicators = function () {
            var e = $("#carousel");
            if (e.length) {
                var t = $('<ol class="carousel-indicators"/>');
                e.find(".carousel-inner .item").each(function (a) {
                    t.append(
                        $("<li>")
                            .attr("data-target", "#" + e.attr("id"))
                            .attr("data-slide-to", a)
                            .toggleClass("active", 0 === a)
                    );
                }),
                    e.prepend(t);
            }
        });
    var c = Object.create(d);
    function h(e) {
        return (e = e.trim().replace(/[\(\)]/g, ""));
    }
    (c.snippets = {}),
        (c.documentReady = function () {}),
        (c.cartContentLoaded = function (e) {
            $("<tr class='top'><td colspan='2'>Produkt</td><td>Dostupnost</td><td>Množstv\xed</td><td>Cena za kus</td><td>Cena celkem</td></tr>").prependTo("body.in-kosik .cart-table:not(.with-disc) tbody"),
                $("<tr class='top'><td colspan='2'>Produkt</td><td>Dostupnost</td><td>Množstv\xed</td><td>Cena za kus</td><td>Sleva</td><td>Cena celkem</td></tr>").prependTo("body.in-kosik .cart-table.with-disc tbody"),
                $(".cart-row>div.col-md-4 .next-step-back").insertAfter(".summary-wrapper, .cart-content:not(.summary-wrapper) .next-step").addClass("step-back-cart ready"),
                $(".price-wrapper .price-label.price-primary").text("Celkov\xe1 cena:"),
                $(".price-wrapper .price-label.price-secondary").text("Celkov\xe1 cena bez DPH:"),
                $("body.in-kosik .next-step-forward").text("POKRAČOVAT K V\xddBĚRU DOPRAVY"),
                $('<div class="form-group"><input type="checkbox" name="coupontoggler" id="coupontoggler" value="1"><label for="coupontoggler" class="whole-width">M\xe1m slevov\xfd kup\xf3n</label></div>').prependTo(".discount-coupon"),
                $("#coupontoggler").click(function () {
                    $(".discount-coupon form").toggleClass("active");
                });
        }),
        (c.initTipProductBasket = function (e) {}),
        (c.injectTipProductPrice = function () {}),
        (c.storeOrderInfo = function () {}),
        (c.displayOrderInfo = function () {});
    var f = Object.create(d);
    (f.snippets = {}),
        (f.contentLoaded = function (e) {
            this.initProductBlocks(e), this.initFilters(e), this.initAdvancedOrder(e), this.initCategoryTopBottom(e), this.initTopBanner(), this.initCategorySubCount(e);
        }),
        (f.initProductBlocks = function (e) {
            $(".products-block .product").each(function () {
                t(this) && f.initProductBlock($(this), e);
            }),
                $(".mobile .category-header").insertBefore("#products"),
                $("#productsTop .product").each(function () {
                    if (tb.dom.oneTime(this, "initProductBlocks")) {
                        var e = $(this).find(".name").attr("href");
                        $(this).find(".p-bottom").appendTo($(this).find(".p-in-in")), $("<a class='btn btn-primary'>Detail</a>").attr("href", e).appendTo($(this).find(".p-in-in"));
                    }
                });
        }),
        (f.initProductBlock = function (e, t) {
            $(".availability:contains('Skladem')").addClass("in-stock"),
                e.find(".p-bottom .p-desc").insertAfter(e.find(".name")),
                e.find(".flag.flag-discount .price-standard").insertBefore(e.find(".price.price-final")).parent().addClass("discount"),
                $(
                    '<span class="quantity"><input type="text" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" data-max="9999" data-min="1"><span class="increase" title="Zv\xfdšit množstv\xed"></span><span class="decrease" title="Sn\xedžit množstv\xed"></span></span>'
                )
                    .prependTo(e.find(".p-bottom .p-tools .pr-action:not(.done)"))
                    .parent()
                    .addClass("done"),
                e.find(".availability").prependTo(e.find(".p-tools")),
                e.find(".price-additional").appendTo(e.find(".prices")),
                e.find(".prices").prependTo(e.find(".p-tools"));
            var a,
                n = e.find(".availability-amount");
            n.text(("" !== (a = (a = n.text()).trim().replace(/[\(\)]/g, "")) && -1 === a.indexOf("ks") && (a += " "), a));
        }),
        (f.initTopBanner = function () {
            $(".type-category").length &&
                !$(".c-category-top").length &&
                ($(".c-category-top").length ||
                    ($(".category-title").prependTo("body.type-category #content-wrapper").wrapAll("<div class='c-category-top'></div>"),
                    $(".category-perex:not(.empty-content)").appendTo(".c-category-top"),
                    $(".c-category-top .category-perex:not(.empty-content)").wrapInner("<div class='category-perex__wrap'></div>"),
                    $(".sidebar-category").insertAfter(".category-perex__wrap"),
                    $(".c-category-top .category-perex .bottom-text").insertAfter(".pagination-wrapper"),
                    $(".subcategories").appendTo(".c-category-top")),
                $(".category-perex:not(.empty-content)").insertAfter(".category-title"));
        }),
        (f.initAdvancedOrder = function (e) {
            var a = $(".advanced-order");
            a.length &&
                t(a) &&
                ($("<div onclick='shoptet.modal.close();' class='extra backto btn btn-secondary'>Zpět do obchodu</div>").prependTo(".advanced-order .extras-wrap"),
                $(".advanced-order .extras-wrap .extra.step .btn").html("Pokračovat do koš\xedku"),
                $(".advanced-order > .h1:not(.advanced-order-suggestion)").html("\xdaspěšně jste přidali do koš\xedku"),
                $(".advanced-order > .h1:not(.advanced-order-suggestion), .advanced-order > .h2").wrapAll("<div class='adv-wrap'></div>"),
                a.closest("#cboxContent").addClass("cbox-advanced"),
                $(document).one("cbox_closed", function () {
                    $("#cboxContent").removeClass("cbox-advanced");
                }));
        }),
        (f.visibleFilters = { 0: !0 }),
        (f.initFilters = function () {
            t($("body")) &&
                ($("body").on("click", ".filter-section, .slider-wrapper", function (e) {
                    var t = $(this),
                        a = $(e.target),
                        n = t.is(".slider-wrapper") ? 0 : t.index() + 1;
                    t.is(".active")
                        ? a.closest("h4").length && (t.removeClass("active"), t.find("form, .slider-inner").slideUp(), (f.visibleFilters[n] = !1))
                        : (t.addClass("active"), t.find("form, .slider-inner").slideDown(), (f.visibleFilters[n] = !0));
                }),
                $(".filter-section-boolean, .filter-section-manufacturer").each(function () {
                    f.visibleFilters[$(this).index()] = !0;
                })),
                $(".filter-section.filter-section-boolean").addClass("added");
            var e = $("#category-header > form fieldset");
            if (t(e, "initFilters")) {
                var a = $('<select class="mobile-sort"/>');
                e.find("input[type=radio]").each(function () {
                    var e = $(this);
                    a.append($("<option/>").prop("value", e.prop("value")).prop("selected", e.is(":checked")).text(e.next("label").text().trim()));
                }),
                    a.on("change", function (t) {
                        t.preventDefault();
                        var a = $(this).val();
                        e.find('input[type=radio][value="' + a + '"]')
                            .prop("checked", !0)
                            .trigger("click");
                    }),
                    e.after(a);
            }
            $(".top-h3").length ||
                ($("<h3 class='top-h3'>Filtrov\xe1n\xed</h3>").insertBefore("#filters"),
                $(".mobile .top-h3").click(function () {
                    $("#filters").toggleClass("visible");
                })),
                tb.dom.oneTimeContents("#filters", "initFilters") && ($("#filters").removeClass("visible"), $(".slider-wrapper").children().slice(1).wrapAll('<div class="slider-inner"/>'), f.visibleFilters[0] || $(".slider-inner").hide()),
                $(".filter-section, .slider-wrapper").each(function () {
                    var e = $(this),
                        t = e.is(".slider-wrapper") ? 0 : e.index() + 1;
                    f.visibleFilters[t] && (e.addClass("active"), e.find("form, .slider-inner").show());
                });
        }),
        (f.initCategoryTopBottom = function () {
            $(".type-category").length && !$(".c-category-top").length && t($("#products"), "initCategoryTopBottom") && ($(".subcategories").addClass("ready"), $(".c-category-top").addClass("ready"));
        }),
        (f.initCategoryPerexReadMore = function () {
            $(".category-perex").removeClass("max-height non-max-height"),
                $(".category-perex:not(.empty-content)").innerHeight() > 89 &&
                    ($(".category-perex").addClass("max-height"),
                    $(".read-more-wrap").remove(),
                    setTimeout(function () {
                        $("<div class='read-more-wrap'><div class='read-more-btn btn btn-primary'>Přec\xedst v\xedce</div></div>").insertAfter(".category-perex:not(.empty-content)");
                    }, 10));
        }),
        (f.initCategorySubCount = function () {
            if (tb.dom.oneTime("body", "initCategorySubCount")) {
                var e = $("body.type-category.desktop .subcategories"),
                    t = $("body.type-category.mobile .subcategories");
                e.children("li").length > 20 && e.append(tb.$h("li.more-categories-trigger", [tb.$h("a", { href: "#" }, "Zobrazit v\xedce")])).addClass("more-categories"),
                    t.children("li").length > 8 && t.append(tb.$h("li.more-categories-trigger", [tb.$h("a", { href: "#" }, "Zobrazit v\xedce")])).addClass("more-categories"),
                    $("body").on("click", ".subcategories .more-categories-trigger", function (e) {
                        e.preventDefault(), $(this).closest(".subcategories").addClass("more-categories-active"), $(this).remove();
                    });
            }
        });
    var u = Object.create(d);
    (u.documentReady = function () {
        $(".p-detail .p-info-wrapper"),
            $(".type-post time").insertBefore(".type-post h1").addClass("ready"),
            $(".stars-wrapper").prependTo(".p-info-wrapper"),
            $(".p-detail h1").prependTo(".p-info-wrapper"),
            $(".availability-label:contains('Skladem')").parent().addClass("in-stock"),
            $(".variant-name-wrapper:contains('Skladem')").addClass("in-stock"),
            $(".p-final-price-wrapper").prependTo(".add-to-cart").addClass("visible"),
            $(".p-detail .product-top .flags-default").appendTo(".p-image-wrapper .p-image"),
            $(".p-detail-inner-header").insertAfter(".p-detail-inner h1"),
            $(".p-info-wrapper .availability-value").insertBefore(".p-detail .add-to-cart"),
            $(".p-short-description").insertBefore(".availability-value"),
            $(".p-info-wrapper .chevron-down-after").appendTo(".p-short-description"),
            $(".p-detail .p-short-description .chevron-down-after").html("<span>Detailn\xed popis</span>"),
            $(".p-image-wrapper .flags-extra .flag-freeshipping").insertBefore(".p-detail .add-to-cart"),
            $(".p-info-wrapper .flag.flag-freeshipping .flag-text").text("Doprava zdarma"),
            $(".p-detail .p-info-wrapper .detail-parameters").insertAfter(".availability-value"),
            $("body.type-detail .p-detail .add-to-cart-button").text("DO KOŠ\xcdKU"),
            $(".p-info-wrapper .availability-value").appendTo(".p-detail .p-final-price-wrapper"),
            $(".p-detail").addClass("ready"),
            $(".p-detail #productsAlternative .products-block").insertAfter(".p-detail").removeClass("p-switchable"),
            $(".products-alternative").wrapAll("<div id='prodAlt' class='sim-products'></div>"),
            $("<div class='h4'>Podobn\xe9 produkty</div>").prependTo(".sim-products"),
            $(".p-detail .products-related.products-block").insertAfter(".p-detail").removeClass("p-switchable"),
            $(".products-related").wrapAll("<div id='relProd' class='rel-products'></div>"),
            $("<div class='h4 series-h4'>Souvisej\xedc\xed produkty<span></span></div>").prependTo(".rel-products"),
            $("#relProd .products-related").length &&
                $('<li class="shp-tab"><a href="#relProd" data-external="1" data-force-scroll="true" class="shp-tab-link series-h4">Souvisej\xedc\xed produkty<span></span></a></li>').appendTo(".shp-tabs-holder ul.shp-tabs"),
            $(".shp-tab-link:contains('Podobn\xe9')").parent().remove(),
            $(".sim-products").length && $('<li class="shp-tab"><a href="#prodAlt" data-external="1" data-force-scroll="true" class="shp-tab-link">Podobn\xe9 produkty</a></li>').appendTo(".shp-tabs-holder ul.shp-tabs"),
            $("body.type-detail .p-detail-info").insertAfter(".p-detail-inner h1"),
            $("body.type-detail .detail-parameters th>span:contains('--info')").parent().parent().addClass("info-row"),
            $("body.type-detail .warranty-row").insertAfter(".p-detail-inner h1"),
            $("body.type-detail .p-main-image img").clone().addClass("p-main-image-desc").insertAfter(".basic-description"),
            $("body.type-detail .price-final-holder .pr-list-unit").length &&
                ($("<tr class='unit-tr'><th>Jednotka</th><td></td></tr>").appendTo(".extended-description .detail-parameters"), $(".price-final-holder .pr-list-unit").clone().appendTo(".unit-tr td:nth-of-type(1)")),
            $(".shp-tab-link:contains('Diskuse')").parent().remove(),
            $(".shp-tab-link:contains('Popis')").parent().addClass("active"),
            $("#tab-content #description").addClass("active in"),
            $(".p-detail .variant-table").appendTo(".p-info-wrapper"),
            $(".p-detail #choose-variant").hide(),
            $("body.in-index .products-block, body.type-detail .products-block").each(function () {
                $(this).slick({
                    infinite: !1,
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    dots: !0,
                    responsive: [
                        { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                        { breakpoint: 767, settings: { slidesToShow: 2, slidesToScroll: 1 } },
                    ],
                });
            }),
            $("<div class='bottom-btns --detail'></div><div class='bottom-params'></div>").appendTo("body.type-detail .p-info-wrapper"),
            $(".shipping-options").attr("id", "delivery-options").appendTo(".bottom-btns.--detail"),
            $("body.type-detail .p-code").appendTo(".p-detail-info"),
            $("body.type-detail .series-row, body.type-detail .catalog-row").appendTo(".bottom-params"),
            $("body.type-detail .series-row td").clone().appendTo(".series-h4 span"),
            $("body.type-detail .add-to-cart .quantity, body.type-detail .add-to-cart .add-to-cart-button, .mehub-bonus-product-detail-container").wrapAll("<div class='add-to-cart-wrap'/>"),
            $(".extended-description>h3").text("Parametry"),
            $("<div class='stores-block'><div class='stock-overview'></div><div><a href='/kontakty/'>4 kamenn\xe9 prodejny v Praze a okol\xed</a></div></div>").insertBefore(".p-detail .add-to-cart"),
            $(".p-detail .add-to-cart, .p-detail .stores-block").wrapAll("<div class='add-to-cart-wrapped'/>"),
            document
                .querySelector(".type-detail .stores-block")
                ?.insertAdjacentHTML(
                    "beforebegin",
                    `<div class='stores-tooltip'><h3>Dostupnost:</h3><span class='show-tooltip question-tooltip' data-original-title='Pokud nen\xed zbož\xed dostupn\xe9 na expedičn\xedm skladu, ale je k dispozici na prodejně, je potřeba poč\xedtat s 2-3 dny na expedici zbož\xed.'>?</span></div>`
                ),
            $("#watchdog").click(function () {
                $(".link-icon.watchdog").click();
            }),
            $(".counseling").click(function () {
                $(".link-icon.chat").click();
            }),
            $("body.mobile.type-detail .product-top h1").prependTo(".p-image-wrapper"),
            $("body.type-product.mobile .p-detail-info").insertAfter(".p-detail-inner h1"),
            $(".p-gifts-wrapper").insertAfter(".bottom-btns.--detail").addClass("ready"),
            $("body.type-detail .detail-parameters .info-row").remove(),
            u.initClickableParameters();
    }),
        (u.initTabs = function () {}),
        (u.initClickableParameters = function () {
            $(".detail-parameters .variant-list").each(function () {
                var e = $(this).find("select");
                if (e.length) {
                    e.hide();
                    var t = e.prop("id").replace("parameter-id-", ""),
                        a = $('<div class="parameter-values"/>');
                    e.after(a),
                        e.children("option:not([data-choose])").each(function () {
                            $('<label class="parameter-value-custom"/>').text($(this).text()).attr("data-index", $(this).attr("data-index")).attr("data-value", $(this).attr("value")).appendTo(a);
                        }),
                        a.on("click", "label", function (t) {
                            t.preventDefault();
                            var a = $(this).attr("data-index");
                            e.find("option[data-index=" + a + "]").prop("selected", !0);
                            var n = new Event("change");
                            e[0].dispatchEvent(n);
                        }),
                        e.on("change", n),
                        n(),
                        document.addEventListener("shoptet.variantsSplit.showVariantDependent", updateInStock);
                }
                function n() {
                    var t = e.children(":selected");
                    a.children("label").removeClass("selected"), a.children('label[data-index="' + t.attr("data-index") + '"]').addClass("selected");
                }
                function i() {
                    var e = [];
                    $(".variant-list .hidden-split-parameter, .variant-list .split-parameter").each(function () {
                        var a = this.id.replace("parameter-id-", ""),
                            n = $(this).find("input:checked, option:selected").val();
                        a !== t && "" !== n && e.push([a, tb.common.parseNumber(n)]);
                    });
                    var n = $(".parameter-dependent:contains(Skladem)")
                        .map(function () {
                            return tb.sh.splitVariantCode(tb.sh.extractVariantCode($(this)), !0);
                        })
                        .toArray();
                    a.children("label").each(function () {
                        var a = $(this);
                        n.find(function (n) {
                            var i = !0;
                            for (let o of e) n[o[0]] !== o[1] && (i = !1);
                            return n[t] !== tb.common.parseNumber(a.attr("data-value")) && (i = !1), i;
                        }),
                            a.toggleClass("in-stock", ing);
                    });
                }
            });
        });
    var v = Object.create(d);
    v.hideTabs = function () {};
    var m = Object.create(d);
    (m.bindEvents = function () {
        $(document).on("DynamicContentLoaded ShoptetDOMPageContentLoaded", this.initDateFormat.bind(this));
    }),
        (m.documentReady = function () {
            this.initDateFormat();
        }),
        (m.initDateFormat = function () {
            var e = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
            $(".news-item time").each(function () {
                if (t(this, "blogTime")) {
                    var a,
                        n = $(this).text().trim().split("."),
                        i = parseInt(n[0], 10),
                        o = parseInt(n[1], 10);
                    $(this)
                        .empty()
                        .append($('<div class="time__day"/>').text((a = i) < 10 ? "0" + a : "" + a), $('<div class="time__month"/>').text(e[o - 1]))
                        .appendTo($(this).find(".image"));
                }
            });
        });
    var b = (function () {
        function e(e) {
            var t = $(e.attr("data-target"));
            e.siblings().removeClass("--active"), e.addClass("--active"), t.siblings().removeClass("--active"), t.addClass("--active"), t.is(".slick-initialized") && t.slick("resize");
        }
        let t = tb.dom.createModuleInitializer({
            earlyInit() {
                $("body").on("click", ".products-carousel__navigation>*", function (t) {
                    t.preventDefault(), e($(this)), $(".products-carousel__inner .products-block.products").slick("refresh");
                });
            },
            render() {
                var t = $(".products-carousel__navigation.--ready");
                tb.dom.oneTime(t, "ProductsCarousel") &&
                    (t.children().each(function () {
                        let e = $(this)
                            .attr("class")
                            .match(/([^ ]+-)heading-([^ ]+)/);
                        e && $(this).attr("data-target", "." + e[1] + e[2]);
                    }),
                    e(t.children().first()),
                    $(".products-carousel__navigation>*").removeClass("homepage-group-title"),
                    $(".products-carousel__navigation>div:contains(Pro psy)").addClass("--dogs"),
                    $(".products-carousel__navigation>div:contains(Pro kočky)").addClass("--cats"),
                    $(".products-carousel__navigation>div:contains(Pro hlodavce)").addClass("--rodents"),
                    $(".products-carousel__navigation>div:contains(Pro koně)").addClass("--horses"));
            },
        });
        return { init: t };
    })();
    let g = (function (e, t) {
            function a() {
                let e = $(".p-detail .stock-overview");
                if (e.length) {
                    var t = $(".p-detail .p-code .parameter-dependent:not(.no-display)");
                    t.length || (t = $(".p-detail .p-code>span").last());
                    var a = t.text().trim(),
                        n = $(".p-detail .availability-value .parameter-dependent:not(.no-display) .availability-label");
                    n.length || (n = $(".p-detail .availability-value .availability-label"));
                    var i = tb.common.find(getShoptetDataLayer().product.codes, function (e) {
                            return e.code == a;
                        }),
                        o = i && tb.common.indexBy(i.stocks || [], tb.common.property("id")),
                        r = getShoptetDataLayer().stocks;
                    e.html(
                        r.map(function (e) {
                            var t = "zvolte variantu",
                                a = "choose-variant";
                            if (i) {
                                var r = o[e.id];
                                r ? ((t = "skladem " + r.quantity + " ks"), (a = "0" !== r.quantity ? "in-stock" : "")) : (t = n.text().trim().toLowerCase());
                            }
                            return tb.$h(".stock-overview__stock", [tb.$h(".stock-overview__stock-title", e.title), tb.$h(".stock-overview__stock-amount", t).addClass(a)]);
                        })
                    );
                }
            }
            let n = tb.dom.createModuleInitializer({
                earlyInit() {
                    if (!$("body.type-detail").length) return !1;
                    e.hookAfterVariantChange(a);
                },
                render() {
                    a(),
                        $("body.type-detail .stock-overview__stock-title").html(function (e, t) {
                            return t.replace("Extern\xed", "Expedičn\xed");
                        });
                },
            });
            return { init: n };
        })(tb.m.DetailHooks, tb.$h),
        y = (function (e) {
            let t = tb.dom.createModuleInitializer({
                earlyInit() {
                    if (!$("body.in-kosik").length) return !1;
                },
                render() {
                    var t = $(".cart-table"),
                        a = 0;
                    t.find("tr[data-micro=cartItem]").each(function () {
                        var e,
                            t = $(this).find(".p-price"),
                            n = tb.common.parsePrice(t.find(".price-final").text()),
                            i = n,
                            o = t.find("span.acronym"),
                            r = o.attr("title") || o.attr("data-original-title");
                        r && (e = r.match(/ze standardní ceny ([0-9 ,.]+)/)) && (i = tb.common.parsePrice(e[1])), console.log(r, n, i, e);
                        var s = tb.common.parseNumber($(this).find(".amount").val());
                        a += s * (i - n);
                    });
                    var n = $(".cart-content.summary-wrapper");
                    n.toggleClass("has-you-saved", a > 0), n.find(".you-saved").remove(), a > 0 && n.prepend(e(".you-saved", ["Ušetřili jste ", e("strong", a.ShoptetFormatAsCurrency())]));
                },
            });
            return { init: t };
        })(tb.$h);
    var k,
        w,
        x =
            ((k = []),
            {
                init: tb.dom.createModuleInitializer({
                    domReady: function () {
                        tb.hooks.hookFn("shoptet.ajax.makeAjaxRequest", function (e, t, a) {
                            var n = t[0],
                                i = t[3];
                            return (
                                n === shoptet.config.advancedOrderUrl &&
                                    (i.success = tb.hooks.hookFn(i.success, function (e, t, a) {
                                        var n = t[0].getPayload();
                                        return (
                                            n.content &&
                                                (n.content = (function e(t) {
                                                    for (let a of k) t = a(t);
                                                    return t;
                                                })(n.content)),
                                            e.apply(a, t)
                                        );
                                    })),
                                e.apply(a, t)
                            );
                        });
                    },
                }),
                addContentFilter: function e(t) {
                    k.push(t);
                },
            });
    tb.dom.createModuleInitializer({
        domReady: function () {
            tb.hooks.hookFn("shoptet.cart.functionsForCart", function (e, t, a) {
                return (
                    (w = (function e(t) {
                        var a = { amount: parseInt(t.find("[name=amount]").val(), 10) || 1 };
                        if (t.is("#product-detail-form"))
                            (a.description = t.find(".p-short-description p").first().text().trim()),
                                (a.imageUrl = t.find(".p-main-image img, .slick-current .detailImage img").attr("src")),
                                (a.priceStandard = t.find(".p-final-price-wrapper .price-standard:visible").text().trim()),
                                (a.priceFinal = t.find(".p-final-price-wrapper .price-final:visible").text().trim());
                        else if (t.closest(".p").length) {
                            var n = t.closest(".p");
                            (a.description = n.find(".p-desc").text().trim()),
                                (a.imageUrl = n.find(".image img").attr("data-micro-image")),
                                (a.priceStandard = n.find(".price-standard").text().trim()),
                                (a.priceFinal = n.find(".price-final strong").text().trim());
                        }
                        return a;
                    })($(t[0]))),
                    e.apply(a, t)
                );
            }),
                x.addContentFilter(function (e) {
                    var t = tb.$h("div", [e]),
                        a = t.find(".advanced-order");
                    return a.length && w && a.prepend(tb.$h(".p-image", [tb.$h("img", { src: w.imageUrl })])), t.html();
                });
        },
    }),
        (function () {
            let e = {
                elements: [
                    {
                        selector: "body.type-category .filters-wrapper",
                        usePositionRelative: !0,
                        enabled: () => $(window).width() > 1200,
                        topSentinel() {
                            var e = "#filters-default-position";
                            return ((e = $(e)).length ? e.offset().top : 0) - this.stickyOffset();
                        },
                        bottomSentinel: () => t(".usps-wrap"),
                        stickyOffset() {
                            return this._headerBottom() + 20;
                        },
                        _headerBottom: () => Math.max(t("#header"), t("#header")) - $(window).scrollTop(),
                    },
                ],
            };
            function t(e) {
                return (e = $(e)).length ? e.offset().top + e.height() : 0;
            }
            function a(e, t) {
                return "function" == typeof e ? e.call(t) : e;
            }
            function n() {
                let t = $(window).scrollTop(),
                    n = $(window).height();
                for (let i of e.elements) {
                    let o = $(i.selector);
                    if (!o.length) continue;
                    let r = a(i.enabled),
                        s = a(i.topSentinel, i),
                        d = a(i.bottomSentinel, i),
                        l = a(i.stickyOffset, i);
                    o.each(function () {
                        let e = $(this),
                            a = e.outerHeight(!1),
                            o = r && n - l >= a && d - s >= a;
                        if (i.usePositionRelative) {
                            let p = e.offset().top - e.position().top;
                            t >= s && o ? (t + l + a >= d ? e.css({ top: d - a - p }) : e.css({ top: t + l - p })) : e.css({ top: "" });
                            return;
                        }
                        if (e.hasClass("--placeholder")) return;
                        let c = e.prev(".--placeholder");
                        if ((c.length || (c = e.clone().addClass("--placeholder").insertBefore(e)), t >= s && o)) {
                            let h = e.outerHeight(!1);
                            if (t + l + h >= d) {
                                let f = c.offsetParent().offset().top;
                                e.removeClass("--fixed").css({ left: "", top: d - h - f });
                            } else e.addClass("--fixed").css({ left: c.offset().left, top: l }).width(c.width());
                        } else e.removeClass("--fixed").css({ left: "", top: "" });
                    });
                }
            }
            tb.dom.createModuleInitializer({
                earlyInit() {
                    $(window).on("scroll resize", n), n();
                },
                render() {
                    n();
                },
            });
        })(),
        tb.modules.SlickUnveilFix.init(),
        b.init(),
        g.init(),
        y.init(),
        $(function () {
          //  $("<a href='/oblibene/' class='navBtns favBtn oblibeneBtn' id='favBtn oblibeneBtn'><span class='favourite-count'></span></a>").prependTo(".navigation-buttons"),
                $("<a href='/kontakty/' class='stores-btn'>PRODEJNY</a>").prependTo(".navigation-buttons"),
                $("<span id='navigation-1'><span>Str\xe1nka neexistuje</span></span>").insertAfter("body.id-404 #navigation-first"),
                $(".top-nav-button-account").length && $("body").addClass("user-logged"),
                l.init(),
                c.init(),
                p.init(),
                f.init(),
                u.init(),
                v.init(),
                m.init(),
                tb.ajax.loadSnippets(["hp-blog.html", "heureka.html", "instagram.html"]).then(([e, t, a]) => {
                    $(".custom-footer>div:nth-of-type(6)").clone().insertAfter("body.in-index .banners-row").addClass("usps-wrap"),
                        $(".custom-footer>div:nth-of-type(6)").clone().appendTo("body.type-category .content-wrapper").addClass("usps-wrap"),
                        $(".custom-footer>div:nth-of-type(6)").clone().appendTo("body.type-detail .p-detail-inner").addClass("usps-wrap"),
                        $(".custom-footer>div:nth-of-type(6)").clone().insertAfter("body:not(.in-index, .type-category, .type-detail) .content-wrapper").addClass("usps-wrap"),
                        $(".in-index #content").addClass("ready"),
                        $(".custom-footer>div:nth-of-type(7) form").insertAfter(".newsletter-bottom"),
                        t.clone().insertBefore("#footer"),
                        l.initRefBlock(),
                        a.clone().insertBefore("#footer"),
                        $(".custom-footer>div:nth-of-type(8)>div").appendTo("#instagram-feed"),
                        e.clone().insertBefore("body.in-index .instagram__block"),
                        l.initBlogBlock(),
                        $("#newsWrapper .news-item").each(function () {
                            $(this).find("a.title").clone().insertAfter($(this).find(".text")).html("Cel\xfd čl\xe1nek").addClass("arrow");
                        }),
                        $("body.type-post .news-item-detail time").insertAfter("h1"),
                        $(".news-item-detail").addClass("ready"),
                        $(".custom-footer>div:nth-of-type(9)>div").insertAfter("body.in-index .banners-row"),
                        $(".custom-footer>div:nth-of-type(9)>div").insertBefore("body.id-404 .usps-wrap").addClass("hp-categories-wrap"),
                        $(".custom-footer>div:nth-of-type(10)>div").prependTo("body.in-index.desktop .middle-banners-wrapper+.content-wrapper main.content"),
                        $(".custom-footer>div:nth-of-type(10)>div").prependTo("body.in-index.mobile .body-banners"),
                        $("body.type-index.desktop .middle-banners-wrapper+.content-wrapper main.content div[class*='homepage-products']").appendTo(".products-carousel__inner"),
                        $("body.type-index.mobile div[class*='homepage-products']:not(.homepage-products-7, .homepage-products-heading-7)").appendTo(".products-carousel__inner"),
                        $("body.type-index.desktop .middle-banners-wrapper+.content-wrapper main.content .h4.homepage-group-title").appendTo(".products-carousel__navigation"),
                        $("body.type-index.mobile .h4.homepage-group-title:not(.homepage-products-heading-7)").appendTo(".products-carousel__navigation"),
                        $(".products-carousel__navigation").addClass("--ready"),
                        $("body.in-index.desktop .middle-banners-wrapper").insertBefore(".content-wrapper.homepage-box.welcome-wrapper"),
                        $("body.in-index.mobile .body-banners").insertBefore(".content-wrapper.homepage-box.welcome-wrapper"),
                        $("body.desktop .header-top .search input[type=search]").attr("placeholder", "Co hled\xe1te? Např. Granule pro psy").val("").focus().blur(),
                        $("body.mobile .header-top .search input[type=search]").attr("placeholder", "Co hled\xe1te?").val("").focus().blur(),
                        $("<a href='/login/' class='navBtns logBtn' id='logBtn'></a>").prependTo(".navigation-buttons"),
                        $("#header, .top-navigation-bar").addClass("ready"),
                        $(".in-kontakty .content-inner").addClass("ready"),
                        $(".footer-bottom").wrapInner("<div class='container'></div>"),
                        $("#footer .copyright").html("\xa9 2022 HappyZoo.cz, <a href='#' class='js-cookies-settings'>Nastaven\xed cookies</a>"),
                        $("#footer #signature .title").replaceWith(
                            "<div class='title'><a class='first' href='https://www.shoptetpremium.cz/' target='_blank'>Shoptet Premium</a> | <a href='https://www.mimedigital.cz/' target='_blank'>mime digital</a></div>"
                        ),
                        l.initStoresBlock(),
                        $(".adv__wrap.--career").slick({
                            infinite: !0,
                            slidesToShow: 3,
                            slidesToScroll: 1,
                            dots: !1,
                            responsive: [
                                { breakpoint: 1200, settings: { slidesToShow: 3, slidesToScroll: 1 } },
                                { breakpoint: 767, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                            ],
                        }),
                        l.initHowBlock(),
                        l.initMembersBlock(),
                        //l.initBlogDetailBlock(),
                        l.initFreeSlots(),
                        l.initAboutBuy(),
                        $("body.id-1642").length && l.initOthers(),
                        $("body.id-1660").length && l.initDogs(),
                        $("body.id-1657").length && l.initRodents(),
                        $("body.id-1654").length && l.initSpiders(),
                        $("body.id-1651").length && l.initBirds(),
                        $("body.id-1648").length && l.initTurtles(),
                        $("#categories").addClass("ready"),
                        $(".type-category #content").addClass("ready"),
                        $(".mobile .custom-footer .banner").each(function () {
                            $(this)
                                .find("h4")
                                .click(function () {
                                    $(this).toggleClass("toggled"), $(this).next().slideToggle();
                                });
                        }),
                        $("<div class='btnUp'></div>").appendTo("body"),
                        $(".btnUp").click(function () {
                            $("html, body").animate({ scrollTop: 0 }, 1e3);
                        }),
                        $(window).scroll(function () {
                            $(this).scrollTop() > 400 ? $(".btnUp").fadeIn() : $(".btnUp").stop().fadeOut();
                            var e = $(".btnUp"),
                                t = e.position().top,
                                a = t + e.outerHeight();
                            $("#footer").each(function () {
                                var e = $(this),
                                    n = e.position().top - $(window).scrollTop() + 30,
                                    i = e.position().top - $(window).scrollTop() + e.height();
                                (n >= t && n <= a) || (n <= t && i >= a) || (i >= t && i <= a) ? ($(".btnUp").addClass("--white"), $(".btnUp").removeClass("--black")) : ($(".btnUp").addClass("--black"), $(".btnUp").removeClass("--white"));
                            });
                        }),
                        $(".slider-for").slick({ slidesToShow: 1, slidesToScroll: 1, arrows: !1, fade: !0, asNavFor: ".slider-nav" }),
                        $(".slider-nav").slick({ slidesToShow: 5, slidesToScroll: 1, asNavFor: ".slider-for", dots: !1, focusOnSelect: !0, responsive: [{ breakpoint: 767, settings: { slidesToShow: 2 } }] }),
                        $("body.mobile .top-navigation-bar-menu").clone().insertAfter(".menu-level-1"),
                        $("body.mobile .top-navigation-contacts").clone().insertAfter("#navigation .top-navigation-bar-menu"),
                        $(document).trigger("customSnippetsLoaded"),
                        tb.hooks.signalDomLoad();
                });
        });
    var C = tb.modules;
    /*(C.FavouriteProducts.config.addBtnToDetailCallback = function (e, t) {
        if (
            (($div = tb.$h(".Favourite")),
            setTimeout(function () {
                $div.prependTo(e.find(".bottom-btns.--detail"));
            }, 1),
            $div.toggleClass("remove", t),
            t)
        ) {
            var a = e.find(".flags.flags-default").first();
            a.length || (a = tb.$h(".flags.flags-default.flags-inline").prependTo(e.find(".p-detail-info"))), a.append(tb.$h("span.flag.flag-dklabFav", [tb.$h("span.heart")])), $div.html("Smazat z obl\xedben\xfdch");
        } else e.find(".flag-dklabFav").remove(), $div.html("Přidat do obl\xedben\xfdch");
        return $div;
    }),*/
       // (C.FavouriteProducts.config.renderOptions.showSku = !1),
       // (C.FavouriteProducts.config.renderOptions.showDescription = !1),
        //C.FavouriteProducts.init(),
        tb.m.DetailHooks.init();
})();